<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9reajR/tc-custom/9781504078634.jpg?1726519238879" alt="This image is the cover for the book Carry On, Jeeves, Jeeves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carry On, Jeeves, Jeeves
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Tag along for the misadventures of Bertie Wooster and his genius manservant, Jeeves, in this humorous collection of ten classic stories.</b></p><p>The fun begins when Bertram “Bertie” Wooster hires a wonderful new valet in “Jeeves Takes Charge.” Jeeves proves himself to be quite handy in all sorts of dilemmas, including Bertie’s fiancée asking him to destroy his uncle’s memoirs. In “The Rummy Affair of Old Biffy,” Bertie’s forgetful friend cannot remember his beloved’s surname or address, which leads to a problematic engagement. In “Without the Option,” Bertie accidentally gets his friend Sippy thrown in jail and must pose as him on a visit to the horrible Pringle family. But no matter that trouble, Jeeves is always there to offer a clever solution that yields hilarious results . . .</p><p>Other stories include “The Artistic Career of Corky,” “Jeeves and the Unbidden Guest,” “Jeeves and the Hard-Boiled Egg,” “The Aunt and the Sluggard,” “Fixing It for Freddie,” “Clustering Round Young Bingo,” and “Bertie Changes His Mind.”</p><b>“The funniest writer ever to put words to paper.” —Hugh Laurie</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. G. Wodehouse
      </h2>
      
      <p class="authorDescription body article">P. G. Wodehouse was an English author and one of the most widely read humorists of the twentieth century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d448ad0